/* ==========================================================================
   WHSL — scroll motion

   No dependencies. Reveal classes are applied by JS, so if this file fails to
   load the page renders exactly as it does today; nothing is hidden by CSS
   alone.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Selectors match the theme's existing markup — no Liquid changes needed.
     The artist grid on The Sound of Hoboken is deliberately excluded: 109
     cards revealing on scroll is noise, not polish. */
  var GROUPS = [
    { parent: '.whsl-about', items: '.whsl-eyebrow, .whsl-sec-title, p, .whsl-btn, img' },
    { parent: '.whsl-stats', items: '.whsl-eyebrow, .whsl-sec-title, .whsl-stat' },
    { parent: '.whsl-support', items: '.whsl-eyebrow, .whsl-sec-title, p, .whsl-btn' },
    { parent: '.whsl-news', items: '.whsl-eyebrow, .whsl-sec-title, .whsl-news-card' },
    { parent: '.whsl-shop-cta', items: '.whsl-eyebrow, .whsl-sec-title, p, .whsl-btn' },
    { parent: '.whsl-products', items: '.whsl-eyebrow, .whsl-sec-title, .whsl-prod-card' },
    { parent: '.whsl-give', items: '.whsl-eyebrow, .whsl-sec-title, p, .whsl-btn, a' }
  ];

  function collectTargets() {
    var targets = [];

    GROUPS.forEach(function (group) {
      document.querySelectorAll(group.parent).forEach(function (parent) {
        var items = Array.prototype.slice.call(parent.querySelectorAll(group.items));

        /* Drop nested matches so a heading inside a card doesn't animate twice. */
        items = items.filter(function (el) {
          return !items.some(function (other) {
            return other !== el && other.contains(el);
          });
        });

        items.forEach(function (el, i) {
          el.classList.add('whsl-reveal');
          el.setAttribute('data-whsl-delay', String(Math.min(i, 7)));
          targets.push(el);
        });
      });
    });

    return targets;
  }

  /* ---- Stat counters ------------------------------------------------------
     "100+" counts to 100 and keeps the "+". "10K+" counts to 10, keeps "K+".
     A bare year like 2021 is skipped — a founding date ticking up from zero
     reads as a loading bug, not a flourish.
     ---------------------------------------------------------------------- */
  function setupCounter(el) {
    var raw = el.textContent.trim();
    var match = raw.match(/^(\D*)(\d[\d,.]*)(.*)$/);
    if (!match) return null;

    var prefix = match[1];
    var value = parseFloat(match[2].replace(/,/g, ''));
    var suffix = match[3];

    if (isNaN(value)) return null;
    if (!suffix && /^(19|20)\d{2}$/.test(match[2])) return null;

    return function run() {
      var duration = 1400;
      var start = null;

      function frame(now) {
        if (start === null) start = now;
        var progress = Math.min((now - start) / duration, 1);
        /* easeOutExpo — quick off the line, gentle landing. */
        var eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        el.textContent = prefix + Math.round(value * eased).toLocaleString() + suffix;
        if (progress < 1) requestAnimationFrame(frame);
      }

      el.textContent = prefix + '0' + suffix;
      requestAnimationFrame(frame);
    };
  }

  function init() {
    var targets = collectTargets();

    var counters = new Map();
    document.querySelectorAll('.whsl-stat__num').forEach(function (el) {
      var run = setupCounter(el);
      if (run) counters.set(el, run);
    });

    if (REDUCED || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add('is-in');

          var counter = el.querySelector ? el.querySelector('.whsl-stat__num') : null;
          if (counter && counters.has(counter)) {
            counters.get(counter)();
            counters.delete(counter);
          }

          observer.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
